// extracted by mini-css-extract-plugin
export default {"appVersion":"NbmIC","message":"lhkLm","description":"_tjU7","menuCategoryTitle":"NBac_","tablet":"ME_eU"};